import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PageStyleBaseService } from './page-style-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class PageStyleService extends PageStyleBaseService {

  imageBlobUrl: any;

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Page Style', httpClient, toastrService, url);
  }

  getLogoImage(
    authorizationCode: string,
    afterGetCallback?: (logoImageUrl: string | ArrayBuffer) => void): void {
    this.getImage('/page-style/logo-image', authorizationCode, afterGetCallback, true);
  }

  getLogoImageByPaymentActionId(
    paymentActionId: string,
    afterGetCallback?: (logoImageUrl: string | ArrayBuffer) => void): void {
    this.getImage('/page-style/logo-image-by-payment-action', paymentActionId, afterGetCallback, true);
  }

  getBackgroundImage(
    authorizationCode: string,
    afterGetCallback?: (backgroundImageUrl: string | ArrayBuffer) => void): void {
    this.getImage('/page-style/background-image', authorizationCode, afterGetCallback, true);
  }

  getBackgroundImageByPaymentActionId(
    paymentActionId: string,
    afterGetCallback?: (backgroundImageUrl: string | ArrayBuffer) => void): void {
    this.getImage('/page-style/background-image-by-payment-action', paymentActionId, afterGetCallback, true);
  }

  /**
   * Build the public, company-stable URL of the logo image. This is the URL to reference from the
   * company's IbanXS or AI-Hub HTML and CSS templates, so it must not depend on a payment.
   * @param companySlug The public slug of the company.
   */
  getLogoImageUrlByCompanySlug(companySlug: string): string {
    return this.getApiUrl('/page-style/logo-image/by-company-slug/' + encodeURIComponent(companySlug));
  }

  /**
   * Build the public, company-stable URL of the background image.
   * @param companySlug The public slug of the company.
   */
  getBackgroundImageUrlByCompanySlug(companySlug: string): string {
    return this.getApiUrl('/page-style/background-image/by-company-slug/' + encodeURIComponent(companySlug));
  }

  saveLogoImage(companyId: number, fileToUpload: File, afterSaveCallback?: Function, customMessage?: string,
              afterCompleteCallback?: Function) {
    this.saveImage('/page-style/logo-image', companyId, fileToUpload, afterSaveCallback, customMessage, afterCompleteCallback);
  }

  saveBackgroundImage(companyId: number, fileToUpload: File, afterSaveCallback?: Function, customMessage?: string,
              afterCompleteCallback?: Function) {
    this.saveImage('/page-style/background-image', companyId, fileToUpload, afterSaveCallback, customMessage, afterCompleteCallback);
  }

  deleteLogoImage(companyId: number, fileName: string, afterDeleteCallback?: Function, customMessage?: string,
                afterCompleteCallback?: Function) {
    this.deleteImage('/page-style/logo-image', companyId, fileName, afterDeleteCallback, customMessage, afterCompleteCallback);
  }

  deleteBackgroundImage(companyId: number, fileName: string, afterDeleteCallback?: Function, customMessage?: string,
                afterCompleteCallback?: Function) {
    this.deleteImage('/page-style/background-image', companyId, fileName, afterDeleteCallback, customMessage, afterCompleteCallback);
  }
}
